import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Select, Store} from '@ngxs/store';
import {AuthState} from '../state/auth.state';
import {tap} from 'rxjs/operators';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {

  @Select(AuthState.token) token$: Observable<string>;

  private readonly EXCLUDED_URLS = ['authenticate', 's3.af-south-1.amazonaws.com', 's3.ap-southeast-2.amazonaws.com', 'maps.googleapis.com'];

  constructor(private store: Store, private snackBar: MatSnackBar) {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.EXCLUDED_URLS.findIndex(u => req.url.includes(u)) > -1) {
      return next.handle(req).pipe(tap(this.handleErrorMessage));
    } else {
      return this.handleIntercept(req, next).pipe(tap(this.handleErrorMessage));
    }
  }

  private handleIntercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.store.selectSnapshot<string>(AuthState.token);
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return next.handle(req);
  }

  private handleErrorMessage = (res: HttpResponse<any>): void => {
    if (res.body && res.body.errorType) {
      const config: MatSnackBarConfig = {
        duration: 2000,
        panelClass: 'errorSnackbar'
      };
      const snackBarRef = this.snackBar.open(res.body.errorMessage, 'DISMISS', config);
      snackBarRef.onAction().subscribe(() => {
        snackBarRef.dismiss();
      });
      throw Error(res.body.errorMessage);
    }
  }
}
